import { render, staticRenderFns } from "./MerchantVolTransctionDetail.vue?vue&type=template&id=7b33876d"
import script from "./MerchantVolTransctionDetail.vue?vue&type=script&lang=js"
export * from "./MerchantVolTransctionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports